;
!function () {
  try {
    var e = "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : {};
    e._sentryModuleMetadata = e._sentryModuleMetadata || {}, e._sentryModuleMetadata[new e.Error().stack] = Object.assign({}, e._sentryModuleMetadata[new e.Error().stack], {
      "_sentryBundlerPluginAppKey:localcoin": true
    });
  } catch (e) {}
}();
import clsx from 'clsx';
import React from 'react';
import { useController } from 'react-hook-form';
import type { FormTextAreaProps, TextAreaProps } from './types';
const TextArea = React.forwardRef<HTMLTextAreaElement, TextAreaProps>(({
  label,
  placeholder,
  ...rest
}, ref) => {
  return <div className="flex w-full flex-col">
        <label className="text-body-8 mb-3 font-semibold text-gray-600" htmlFor={rest.id}>
          {label}
        </label>
        <textarea className={clsx('text-body-8 placeholder:text-body-8 focus:border-primary-500 w-full resize-none rounded border border-gray-200 p-3 placeholder:text-gray-400 focus:outline-hidden')} placeholder={placeholder} rows={5} draggable={false} {...rest} ref={ref} />
      </div>;
});
TextArea.displayName = 'TextArea';
export const FormTextArea = ({
  name,
  ...rest
}: FormTextAreaProps) => {
  const {
    field,
    fieldState: {
      error
    }
  } = useController({
    name
  });
  return <TextArea {...field} {...rest} error={error?.message} data-sentry-element="TextArea" data-sentry-component="FormTextArea" data-sentry-source-file="index.tsx" />;
};
export default TextArea;